import { Button } from "./Button";

interface Props {
  title: string;
  message?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Slett",
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(31, 42, 36, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        data-testid="confirm-dialog"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--surface)",
          borderRadius: "var(--r-xl)",
          boxShadow: "var(--shadow-md)",
          padding: 28,
          width: 320,
          maxWidth: "calc(100vw - 32px)",
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-display)",
            fontStyle: "italic",
            fontSize: 22,
            fontWeight: 400,
            letterSpacing: -0.5,
            marginBottom: message ? 8 : 20,
          }}
        >
          {title}
        </div>
        {message && (
          <div
            style={{
              fontSize: 14,
              color: "var(--ink-2)",
              marginBottom: 20,
              lineHeight: 1.5,
            }}
          >
            {message}
          </div>
        )}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <Button
            variant="ghost"
            size="sm"
            onClick={onCancel}
            data-testid="cancel-confirm-button"
          >
            Avbryt
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={onConfirm}
            data-testid="confirm-button"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
